// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cafbab58","570":"d841d4f4","621":"b9eecf3f","828":"a0ac740a"}[chunkId] + ".chunk.js";
};